import Home from '@ui/pages/Home.vue';
import UserPosts from '@ui/pages/UserPosts.vue';
import VueRouter from 'vue-router';
//import CreatePost from '@ui/pages/CreatePost.vue';
//import PlayPost from '@ui/pages/PlayPost.vue';

const Activity = () => import(/* webpackChunkName: "edit" */ "@ui/pages/Activity.vue");
const CreatePost = () => import(/* webpackChunkName: "edit" */ "@ui/pages/CreatePost.vue");
const StartPost = () => import(/* webpackChunkName: "edit" */ "@ui/pages/StartPost.vue");
const CreateFromTemplate = () => import(/* webpackChunkName: "edit" */ "@ui/pages/CreateFromTemplate.vue");
const TemplatesMain = () => import(/* webpackChunkName: "edit" */ "@ui/pages/TemplatesMain.vue");
const PlayPost = () => import(/* webpackChunkName: "play" */ "@ui/pages/PlayPost.vue");
const Recorder = () => import(/* webpackChunkName: "play" */ "@ui/pages/Recorder.vue");
const ToysMain = () => import(/* webpackChunkName: "edit" */ "@ui/pages/ToysMain.vue");
const Help = () => import(/* webpackChunkName: "edit" */ "@ui/pages/Help.vue");
const DownloadClips = () => import(/* webpackChunkName: "edit" */ "@ui/pages/DownloadClips.vue");
const PixiPlay = () => import(/* webpackChunkName: "play" */ "@ui/pages/PixiPlay.vue");
const CreatePostComponent = () => import(/* webpackChunkName: "edit" */ "@ui/organisms/CreatePost.vue");
const TemplateEditor = () => import(/* webpackChunkName: "edit" */ "@ui/organisms/TemplateEditor.vue");

import Login from '@ui/pages/Login.vue';




const PageLoader = (fn, bus) => {
  return () => {
    bus.emit("startLoadingPage");

    const done = () => {
      //console.log('Component loading done');
      bus.emit("doneLoadingPage");
    }

    //console.log('prms', promise);
    const promise = fn()
    promise.then(done, done);

    return promise;

  }
}


function createRouter(bus) {
  const routes = [
    {
      path: '/templates',
      name: 'templates',
      component:PageLoader(TemplatesMain, bus),
      children:[
        {
          path:'edit/:templateId',
          name:'editTemplate',
          component: PageLoader(TemplateEditor, bus)
        }
      ]
    },
    {
      path:'/autosaves',
      name:'autosave',
      component:PageLoader(Activity, bus)
    },
    {
      path:'/toys',
      name:'toys',
      component:PageLoader(ToysMain, bus)
    },
    {
      path:'/help',
      name:'help',
      component:PageLoader(Help, bus)
    },
    {
      path:'/login',
      name:'login',
      component:Login
    },
    {
      path:'/test',
      name:'test',
      component:PageLoader(PixiPlay, bus)
    },
    {
      path:'/user/:username',
      name:'userposts',
      component:UserPosts,
      children:[
        {
          name:'downloadUserClip',
          path:'download/:postId',
          props: true,
          component: PageLoader(DownloadClips, bus)
        }
      ]
    },
    {
      path:'/',
      name:'hot',
      component:Home,
      props:{
        feed:'hot'
      },
      children:[
        {
          name:'downloadClipHot',
          path:'download/:postId',
          props: true,
          component: PageLoader(DownloadClips, bus)
        },
        {
          path:'post/:id',
          name:'play',
          component:PageLoader(PlayPost, bus),
          children:[
            {
              name:'createTextPost',
              path:'text',
              component: PageLoader(CreatePostComponent, bus)
            },
            {
              name:'createImagePost',
              path:'image',
              component: PageLoader(CreatePostComponent, bus)
            }
          ]
        }
      ]
    },
    {
      path:'/new',
      name:'new',
      component:Home,
      props:{
        feed:'new'
      },
      children:[
        {
          name:'downloadClipNew',
          path:'download/:postId',
          props: true,
          component: PageLoader(DownloadClips, bus)
        },
        {
          path:'post/:id',
          name:'playnew',
          component:PageLoader(PlayPost, bus),
          children:[
            {
              name:'createTextPost',
              path:'text',
              component: PageLoader(CreatePostComponent, bus)
            },
            {
              name:'createImagePost',
              path:'image',
              component: PageLoader(CreatePostComponent, bus)
            }
          ]
        }
      ]
    },

    {
      path:'/start/:parentId/:type/',
      name:'start',
      component:PageLoader(StartPost, bus),
    },
    {
      path:'/create/:type/:draftId',
      name:'create',
      component:PageLoader(CreatePost, bus),
    },
    {
      path:'/template/:templateId/:draftId?',
      name:'template',
      component:PageLoader(CreateFromTemplate, bus),
    },
    {
      path:'/record/:id',
      name:'record',
      component:PageLoader(Recorder, bus)
    },

  ]

  const router = new VueRouter({
    mode: 'history',
    //base: process.env.BASE_URL,
    routes,
    scrollBehavior: async (to, from) => {
      //console.log('scroll', to.name);
      if (to.name === 'edit' || to.name === 'create' || to.name === 'play' || to.name === 'createTextPost') {
        //console.log('has', to.hash);
        if (to.hash) {
          return {
            selector: to.hash
          }
        }
      } else {
        console.log('route change', to.name, from.name);
        if ((to.name === 'hot' && from.name === 'new') || (to.name === 'new' && from.name === 'hot')) {
          console.log('scroll to top, i guess');
          const el = document.querySelector('#what-viewing-box');
          if (el.scrollIntoViewIfNeeded) {
            el.scrollIntoViewIfNeeded();
          } else {
            el.scrollIntoView();
          }
          return false;
          /*
          return new Promise( (resolve, reject) => {
            bus.once('postsLoaded', () => {
              document.querySelector('#what-viewing-box').scrollIntoView();
              resolve( {
                selector:'#what-viewing-box'
              }
              )
            });
          });
          */
        } else if ((to.name === 'hot' || to.name === 'new') && to.hash && to.name !== from.name && (from.name||'').indexOf('downloadClip') === -1) {

          console.log('SCROLL TO POST', to.hash);

          return new Promise( (resolve, reject) => {

            bus.once('postsLoaded', () => {
              console.log('posts haven been loaded');
              if (document.querySelector(to.hash)) {
                console.log('now scrolling');
                document.querySelector(to.hash).scrollIntoView();
                resolve({
                  selector: to.hash,
                })
              } else {
                console.log('couldnt find the post');
                resolve({
                  selector: to.hash,
                });
              }
            });

          });
        } else {
          return false;
        }
      }
      return false;
    }
  });

  router.beforeEach( (to, from, next) => {
    //console.log('route change', to, from);
    if (from.name === 'create' && to.name !== 'create') {
      if (to.query.posted) {
        return next();
      } else {
        bus.emit('navigateAwayFromEditor', {next});
      }
    } else {
      next();
    }
  });
  return router;
}

// from the internets
if (process.browser) {
  if (!Element.prototype.scrollIntoViewIfNeeded) {
    Element.prototype.scrollIntoViewIfNeeded = function (centerIfNeeded) {
      centerIfNeeded = arguments.length === 0 ? true : !!centerIfNeeded;

      var parent = this.parentNode,
          parentComputedStyle = window.getComputedStyle(parent, null),
          parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width')),
          parentBorderLeftWidth = parseInt(parentComputedStyle.getPropertyValue('border-left-width')),
          overTop = this.offsetTop - parent.offsetTop < parent.scrollTop,
          overBottom = (this.offsetTop - parent.offsetTop + this.clientHeight - parentBorderTopWidth) > (parent.scrollTop + parent.clientHeight),
          overLeft = this.offsetLeft - parent.offsetLeft < parent.scrollLeft,
          overRight = (this.offsetLeft - parent.offsetLeft + this.clientWidth - parentBorderLeftWidth) > (parent.scrollLeft + parent.clientWidth),
          alignWithTop = overTop && !overBottom;

      if ((overTop || overBottom) && centerIfNeeded) {
        parent.scrollTop = this.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + this.clientHeight / 2;
      }

      if ((overLeft || overRight) && centerIfNeeded) {
        parent.scrollLeft = this.offsetLeft - parent.offsetLeft - parent.clientWidth / 2 - parentBorderLeftWidth + this.clientWidth / 2;
      }

      if ((overTop || overBottom || overLeft || overRight) && !centerIfNeeded) {
        this.scrollIntoView(alignWithTop);
      }
    };
  }

}
export { createRouter }
